module.exports = __webpack_public_path__ + "static/media/rushabhpavers_in.aa5b3e11.png";